import { render, staticRenderFns } from "./LaudoListagem.vue?vue&type=template&id=199edefa&scoped=true&lang=pug"
import script from "./LaudoListagem.vue?vue&type=script&lang=js"
export * from "./LaudoListagem.vue?vue&type=script&lang=js"
import style0 from "./LaudoListagem.vue?vue&type=style&index=0&id=199edefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199edefa",
  null
  
)

export default component.exports